var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompany(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 21,
    viewBox: "0 0 26 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2484 20.3074V0H7.63579V3.36627H1.75158V20.3073H0V20.9915H26V20.3073L24.2484 20.3074ZM23.5642 0.656842V20.28H17.9537V15.5178H13.9305V20.3073H8.29263V0.656793L23.5642 0.656842ZM17.2695 20.3074H14.5874V16.2021H17.2695V20.3074ZM2.43579 4.02316H7.63579V20.3074H2.43579V4.02316Z",
    fill: "#564AB1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0695 2.10742H9.71582V4.46111H12.0695V2.10742ZM11.4126 3.7769H10.4V2.76431H11.4126V3.7769Z",
    fill: "#564AB1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4357 2.10742H13.082V4.46111H15.4357V2.10742ZM14.7515 3.7769H13.7389V2.76431H14.7515V3.7769Z",
    fill: "#564AB1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7746 2.10742H16.4209V4.46111H18.7746V2.10742ZM18.1177 3.7769H17.1051V2.76431H18.1177V3.7769Z",
    fill: "#564AB1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1408 2.10742H19.7871V4.46111H22.1408V2.10742ZM21.484 3.7769H20.4715V2.76431L21.484 2.76412V3.7769Z",
    fill: "#564AB1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0695 5.44629H9.71582V7.79997H12.0695V5.44629ZM11.4126 7.11576H10.4V6.10318H11.4126V7.11576Z",
    fill: "#564AB1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4357 5.44629H13.082V7.79997H15.4357V5.44629ZM14.7515 7.11576H13.7389V6.10318H14.7515V7.11576Z",
    fill: "#564AB1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7746 5.44629H16.4209V7.79997H18.7746V5.44629ZM18.1177 7.11576H17.1051V6.10318H18.1177V7.11576Z",
    fill: "#564AB1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1408 5.44629H19.7871V7.79997H22.1408V5.44629ZM21.484 7.11576H20.4715V6.10318L21.484 6.10299V7.11576Z",
    fill: "#564AB1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0695 8.8125H9.71582V11.1662H12.0695V8.8125ZM11.4126 10.482H10.4V9.46939H11.4126V10.482Z",
    fill: "#564AB1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4357 8.8125H13.082V11.1662H15.4357V8.8125ZM14.7515 10.482H13.7389V9.46939H14.7515V10.482Z",
    fill: "#564AB1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7746 8.8125H16.4209V11.1662H18.7746V8.8125ZM18.1177 10.482H17.1051V9.46939H18.1177V10.482Z",
    fill: "#564AB1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1408 8.8125H19.7871V11.1662H22.1408V8.8125ZM21.484 10.482H20.4715V9.46939H21.484V10.482Z",
    fill: "#564AB1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0695 12.1516H9.71582V14.5053H12.0695V12.1516ZM11.4126 13.8484H10.4V12.8358H11.4126V13.8484Z",
    fill: "#564AB1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4357 12.1516H13.082V14.5053H15.4357V12.1516ZM14.7515 13.8484H13.7389V12.8358H14.7515V13.8484Z",
    fill: "#564AB1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7746 12.1516H16.4209V14.5053H18.7746V12.1516ZM18.1177 13.8484H17.1051V12.8358H18.1177V13.8484Z",
    fill: "#564AB1"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1408 12.1516H19.7871V14.5053H22.1408V12.1516ZM21.484 13.8484H20.4715V12.8358H21.484V13.8484Z",
    fill: "#564AB1"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0695 15.5178H9.71582V17.8715H12.0695V15.5178ZM11.4126 17.1873H10.4V16.1747H11.4126V17.1873Z",
    fill: "#564AB1"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1408 15.5178H19.7871V17.8715H22.1408V15.5178ZM21.484 17.1873H20.4715V16.1747H21.484V17.1873Z",
    fill: "#564AB1"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M3.85938 5.44629V7.79997H6.21306V5.44629H3.85938ZM5.52885 7.11576H4.51607V6.10318H5.52865L5.52885 7.11576Z",
    fill: "#564AB1"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M3.85938 11.1662H6.21306V8.8125H3.85938V11.1662ZM4.51612 9.46939H5.5287L5.52889 10.482H4.51611L4.51612 9.46939Z",
    fill: "#564AB1"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M3.85938 14.5053H6.21306V12.1516H3.85938V14.5053ZM4.51612 12.8358H5.5287V13.8484H4.51612V12.8358Z",
    fill: "#564AB1"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M3.85938 17.8715H6.21306V15.5178H3.85938V17.8715ZM4.51612 16.1747H5.5287V17.1873H4.51612V16.1747Z",
    fill: "#564AB1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.e1d6a00df3dc462572d044137fb7abc5.svg";
export { ForwardRef as ReactComponent };